/* GENERATED from design-system/assets/icons/chevron-down.svg — do not edit.
 * Regenerate: node design-system/scripts/build-assets.mjs */
import * as React from "react";
import type { IconProps } from "./props";
const ChevronDown = ({ size, ...props }: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? "1em"}
    height={size ?? "1em"}
    {...props}
  >
    <path
      d="M18 9L12 15L6 9"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ChevronDown;
